import type { EventTypeView, MarketId, MarketView } from '@ps/isp-web-services-types';
import { useSelector } from 'react-redux';

import { useWidget } from '@swf/core/hooks/useWidget';
import type { RootState } from '@swf/core/store';

import type { BasicMarketTemplatesModel } from '../models/market-templates/basic';

interface NormalisedBasicData {
  eventType: EventTypeView;
  market: MarketView | undefined;
}

interface Props {
  marketId: MarketId;
}

export const useNormalisedBasicData = (props: Props): NormalisedBasicData => {
  const { widgetSelect } = useWidget<never, BasicMarketTemplatesModel>();

  const market = useSelector((state: RootState) => widgetSelect.market(state, props.marketId));

  const eventType = useSelector((state: RootState) =>
    widgetSelect.eventType(state, market?.eventTypeId ?? Number.MAX_SAFE_INTEGER)
  );

  return {
    eventType,
    market
  };
};
